export class Microsoft365Group {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groupId",
            "baseName": "groupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "mail",
            "baseName": "mail",
            "type": "string",
            "format": ""
        },
        {
            "name": "groupType",
            "baseName": "groupType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365Group.attributeTypeMap;
    }
    constructor() {
    }
}
